export const InvoiceGateways = [
  {name: "سامان (SAMAN)", id: 1},
  {name: "پاسارگاد (PASARGAD)", id: 2},
  {name: "زرین پال (ZARINPAL)", id: 3},
  {name: "کیف پول (WALLET)", id: 4},
  {name: "بازار (BAZZAR)", id: 5},
];

export const InvoiceFilterGateway = [
  {name: "سامان (SAMAN)", value: 1},
  {name: "پاسارگاد (PASARGAD)", value: 2},
  {name: "زرین پال (ZARINPAL)", value: 3},
  {name: "کیف پول (WALLET)", value: 4},
  {name: "بازار (BAZZAR)", value: 5},
];

export const InvoiceFilterTypes = [
  {name: "مکالمه (Conversation)", value: 1},
  {name: "سابسکریپشن (Subscription)", value: 2},
];

export const InvoiceTypes = [
  {id: 1, name: "مکالمه (Conversation)"},
  {id: 2, name: "سابسکریپشن Subscription)"}
]

export const InvoiceStatus = [
  {id: 0, name: "کامل شده (COMPLETED)"},
  {id: 1, name: "انتظار (PENDING)"},
  {id: 2, name: "لغو شده (CANCELED)"}
]

export const InvoiceFilterStatus = [
  {value: 0, name: "کامل شده (COMPLETED)"},
  {value: 1, name: "انتظار (PENDING)"},
  {value: 2, name: "لغو شده (CANCELED)"}
]